export const commonTags: Record<string, string | undefined> = {};
